import { ApiService } from "../ApiService";
import {
  AdminSellBook,
  ResultsDTO
} from "Types";


export const AdminSellBooksApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllSellBooks: builder.query<AdminSellBook[], void>({
      query: () => ({
        url: "/admin/sell-products/",
        method: "GET",
      }),
      transformResponse: (response: ResultsDTO<AdminSellBook[]>) => response.results ?? [],
    }),

    getSellBookById: builder.query<AdminSellBook, number>({
      query: (id) => ({
        url: `/admin/sell-products/${id}`,
        method: "GET",
      }),
      transformResponse: (response: ResultsDTO<AdminSellBook>) => response.results,
    }),

    updateSellBookStatus: builder.mutation<
      ResultsDTO,
      { id: number; status: "Purchased" | "Rejected" }
    >({
      query: ({ id, status }) => ({
        url: `/admin/sell-products/${id}`,
        method: "PUT",
        params: { status },
        headers: {
          origin: "origin",
        },
      }),
    }),
  }),
});

export const {
  useGetAllSellBooksQuery,
  useGetSellBookByIdQuery,
  useUpdateSellBookStatusMutation,
} = AdminSellBooksApiSlice;
